import React, { Component } from 'react';
import { Button, Popconfirm, Spin, Table, PageHeader, Layout, message, Space, Tooltip, Typography } from 'antd'
import axios from 'axios';
import { Link } from "react-router-dom";
import { BiStoreAlt } from 'react-icons/bi'
import { BsBox } from 'react-icons/bs'



//Componentes
import { IconDelete, IconEdit } from '../../Widgets/Iconos';
import FloatingButton from "../../Widgets/Floating Button/FloatingButton";
import ModalInventarios from "./ModalInventarios"

const { Content } = Layout;
const { Text } = Typography;

/**
 * @export
 * @class Inventarios
 * @extends {Component}
 * @description Vista de Inventarios
 */
export default class Inventarios extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            modalVisible: false,
            inventarios: [],
            inventario_id: undefined,

            page: 1,
            total: 0,

            filtroSearch: '',
            searching: true,

            windowWidth: window.innerWidth,
        }
    }

    componentDidMount() {
        //Mostrar input superior de busqueda
        //Para acceder al valor del input = this.props.search
        this.props.updateFilterSearch(true);

        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');

        window.addEventListener('resize', this.handleResize);

        this.getInventarios()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    /**
     * @memberof Inventarios
     * @method handleResize
     * @description Actualiza el ancho de la ventana, para saber si mostrar el scroll horizontal de la tabla
     */
    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    }


    componentDidUpdate() {
		const filtro = this.state.filtroSearch;
        const propFiltro = this.props.search;

        if (filtro !== propFiltro && this.state.searching == true) {
            this.getInventarios();
            this.state.searching = false;
        }
	}



    /**
     * @memberof ModalAreas
     * @method getInventarios
     * @description Obtiene una area de la DB
     */
    getInventarios = (page) => {
        let search = this.props.search;

        this.setState({ loading: true })
        axios.get('/inventarios/list', {
            params: {
				page: page,
                paginate: true,
				search
			}

        }).then(response => {
            console.log(response.data.data)
            this.setState({
                inventarios: response.data.data.itemsList,
                page: response.data.data.paginator.currentPage,
                total: response.data.data.paginator.itemCount,
                searching: true,
                filtroSearch: search

            })
        }).catch(error => {
            console.log(error)
            message.error('Error al traer la información.')
        }).finally(() => this.setState({ loading: false }))
    }

    /**
     * @memberof Inventarios
     * @method componentDidUpdate
     * @description Actualiza la vista si se buscan datos
     */
    deleteInventario = (id) => {
        this.setState({ loading: true })
        axios.post('/inventarios/delete',{ id: id })
        .then(() => {
            this.getInventarios()
            message.success('Inventario eliminado')
        })
        .catch(error => {
            message.error(error?.response?.data?.message || 'Error al eliminar el inventario')
        })
        .finally(() => this.setState({ loading: false }))
    }

    render() {
        return (
            <>
                <Spin spinning={false}>
                    <PageHeader
                        className="site-page-header custom-page-header"
                        title="Inventarios"
                        extra={<span className="page-header-extra">
                             {`${this.state.total} ${this.state.total === 1 ? 'inventario' : 'inventarios'}`}
                        </span>}
                        
                    />

                    <Content className="admin-content content-bg pd-1 mb-3">
                        <Table
                            loading={this.state.loading}
                            scroll={{ x: 700 }}
                            rowKey={record => record._id}
                            columns={[
                                {
                                    title: 'Cliente',
                                    dataIndex: 'cliente',
                                    key: 'cliente',
                                    render: (text, record) => (
                                        <h3>{record.cliente?.razon_social || record.cliente?.nombre}</h3>
                                    ),
                                },
                                {
                                    title: 'Descripción',
                                    dataIndex: 'descripcion',
                                    key: 'descripcion',
                                    render: (text, record) => (
                                        <span>{record.descripcion ? record.descripcion : 'Sin Descripción'}</span>
                                    ),
                                },
                                {
                                    title: 'Acciones',
                                    key: 'actions',
                                    fixed: 'right',
                                    width: '210px',
                                    render: (text, record) => (
                                        <Space>
                                            <Link to={`/admin/inventarios/${record._id}/almacenes`}>
                                                <Tooltip title="Almacenes">
                                                    <Button
                                                        type="primary"
                                                        icon={<BiStoreAlt style={{ position: 'relative', top: 2 }} />}
                                                    />
                                                </Tooltip>
                                            </Link>
                                            <Link to={`/admin/inventarios/${record._id}/productos`}>
                                                <Tooltip title="Productos">
                                                    <Button
                                                        type="primary"
                                                        icon={<BsBox style={{ position: 'relative', top: 2 }} />}
                                                    />
                                                </Tooltip>
                                            </Link>
                                            <Button
                                                type="primary"
                                                icon={<IconEdit />}
                                                title="Editar"
                                                onClick={() => { this.setState({ modalVisible: true, inventario_id: record._id }) }}
                                            />
                                            <Popconfirm
                                                placement="topRight"
                                                title="¿Deseas eliminar este Inventario?"
                                                onConfirm={() => this.deleteInventario(record._id)}
                                                okText="Si"
                                                cancelText="No"
                                            >
                                                <Button
                                                    type="primary"
                                                    icon={<IconDelete />}
                                                    title="Eliminar"
                                                    danger
                                                />
                                            </Popconfirm>
                                        </Space>
                                    ),
                                },
                            ]}
                            dataSource={this.state.inventarios}
                            pagination={{
                                onChange: this.getInventarios,
                                current: this.state.page,
                                pageSize: 10,
                                total: this.state.total,
                                position: ['bottomLeft'],
                            }}
                            locale={{ emptyText: 'Sin Inventarios' }}
                        />
                    </Content>

                    <FloatingButton title="Nuevo registro" onClick={() => this.setState({ modalVisible: true })} />

                    <ModalInventarios
                        visible={this.state.modalVisible}
                        inventario_id={this.state.inventario_id}
                        onClose={() => {
                            this.setState({ modalVisible: false, inventario_id: undefined })
                            this.getInventarios()
                        }}
                    />

                </Spin>
            </>
        )
    }
}
